module.exports = "export default function(context) {\r\n  return {\r\n    TemplateLiteral(node) {\r\n      context.report(node, 'Do not use template literals');\r\n    }\r\n  };\r\n};\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/js/transformers/eslint/codeExample.txt
 ** module id = ./src/parsers/js/transformers/eslint/codeExample.txt
 ** module chunks = 0
 **/